<template>
  <div class="shoppingCart" style="margin-top: 220px;">
    <div class="shop-carBox comWidth">
      <form action="" id='cart'>
        <table class="table table-bordered">
          <thead>
          <tr style="background-color:#eee;">
            <th>商品名稱</th>
            <th>商品價格</th>
            <th>購買數量</th>
            <th>小計</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="(shopList ,index) in shopDataLists" :key='shopList.id'>
              <td @click="goDetails(shopList)">
                <a target="_blank" class="f6">
                  <img class="shop-pic" :src="shopList.goods_thumb_url" alt="極草·5X冬蟲夏草純粉片（經典含片）0.25克/片×60片/瓶">
                  <p class="shop-title" >{{shopList.goods_name}}<br>
                  </p>
                </a>
              </td>
              <td>
                <p class="shop-money" >￥{{shopList.price}}</p>
              </td>
              <td class="padding40">
                <el-input-number v-model="shopList.num" @change="val => numChange(val, shopList)" :min="1" label="描述文字"></el-input-number>
                <!--<div class="shop_number">-->
                  <!--<a class="remove_shop" href="javascript:;">-->
                    <!--<i class="iconfont icon-jiajian-">-</i>-->
                  <!--</a>-->
                  <!--<input disabled="disabled" class="number_input" name='goods_number[8070]' type="text" value=" 1">-->
                  <!--<a class="add_shop" href="javascript:;">-->
                    <!--<i class="iconfont icon-jiajian-1">+</i>-->
                  <!--</a>-->
                <!--</div>-->
              </td>
              <td>
                <p class="shop-money subtotal" >￥{{(shopList.price * shopList.num).toFixed(2)}}</p>
              </td>

              <td>
                <div class="shop_operation">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="deleteData(shopList,index)">删除</el-button>
             <!--     <el-button
                    v-if="shopList.is_favorite==0"
                     class="default-btn"
                     size="mini"
                     @click="collection(shopList)" >收藏</el-button>
                  <el-button
                    v-if="shopList.is_favorite==1"
                     class="default-btn"
                     size="mini">已收藏</el-button>-->
                </div>
              </td>
            </tr>
          </tbody>

        </table>


        <div class="Allmoney_box">
          總價： <span style="color: #cd0000">￥</span> <span class="Allmoney">{{allMoneys}} </span>
        </div>
        <div class="clearBoth"></div>
        <div class="btn_box fr">
          <div></div>
          <div>
            <a><router-link :to="{name:'ProductPage'}" class="btn btn-default"  tag="div">繼續購物</router-link></a>

            <a @click="settlement"><div style="width: 160px;" class="btn btn-danger">去結算 </div></a>
          </div>
        </div>
      </form>
      <div class="shopCar-tishi">
        <h5>小貼士：</h5>
        1.受限於銀行支付額度的相關規定，您可能會遇到銀行支付限額低於訂單金額而無法成功購買的情況。為了方便您購買，您可以根據銀行支付限額的要求，將您的大額訂單拆分為多個訂單進行購買。<a href="/static/wechat_limit_2017.pdf" target="_blank">《微信支付限額表》</a><a href="/static/bank_limit_2017.pdf" target="_blank">《銀聯支付限額》</a><br>
        2.如果您想盡快支付訂單完成購買，您還可以撥打+86 400-061-3311查詢離您最近的服務門店尋求幫助。
      </div>
    </div>
    <!--导航-->
    <NavB :titleChild="titleChild"/>
  </div>
</template>

<script>
  import NavB from '@/pages/detailsPage/NavB'
  //common.js
  import { getLocalStorage ,setLocalStorage,ifSignIn} from '@/utils/common';
  import { getToken } from '@/utils/auts'
  //api
  import {collectionGood} from '@/api/collection';
export default {
  name: 'ShoppingCart',
  components:{
    NavB
  },
  data () {
    return {
      titleChild:[{name:'首頁',src:'HomePage'},{name:'購物車',src:'ShoppingCart'}],
      //购物车数据
      shopDataLists:[]
    }
  },
  methods:{

      /*删除购物车数据*/
    deleteData(shopList,index) {
      this.$confirm('此操作删除该商品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        lockScroll:false,
        type: 'warning'
      }).then(() => {
        this.shopDataLists.forEach((item,index) =>{
            if(shopList.id === item.id){
               this.shopDataLists.splice(index,1);
              return this.shopDataLists;
            }
        });
        setLocalStorage('shopDataLists' , this.shopDataLists);
        this.$message.success('删除成功');
        this.getDataShop();
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    /*收藏*/
    collection(shopList){
          collectionGood(shopList.id).then(res =>{
            this.$message.success('收藏成功');
          })
    },

    numChange(val,row){
      this.$set(row, 'num', val)
      this.$nextTick(() => {
        this.$set(row, 'num', Math.floor(val))
      })
    },
    /*去结算*/
    settlement(){
      //判断是否登录
      ifSignIn(this, ()=> {
        //存入去结算数据
        var purchaseData = [];
        purchaseData = this.shopDataLists;
        if(purchaseData.length == 0){
          this.$message.error('購物車暫時沒有商品哦');
          setTimeout( ()=> {
            this.$router.push({name:'ProductPage'});
          },1000)
        }else {
          purchaseData.forEach(item =>{
            return item.smallPlan = (item.num * item.price).toFixed(2)
          });
          setLocalStorage('purchaseData' , purchaseData);
          setLocalStorage('price' , this.allMoneys);
          this.$router.push({name:'SettlementShop'});
        }
      });
    },

    /*获取加入购物车的数据*/
    getDataShop(){
      getLocalStorage('shopDataLists' ,  (res)=>{
        this.shopDataLists = res;
      })
    },


    /*点击进去商品详情页*/
    goDetails(item){
      this.$router.push({
        name:'ShopDetails',
        query:{
          id:item.id
        }
      })
    },
  },

  computed:{
    allMoneys(){
      var total = 0;
      this.shopDataLists.forEach((p1) => {
        return total += parseFloat(p1.price) * parseFloat(p1.num)
      })
      return total.toFixed(2);
    }
  },

  created(){
      //获取购物车数据
      this.getDataShop();
      //判断是否登录
    ifSignIn(this,function () {})
    window.scrollTo(0,0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../css/shoppingCart.less";
</style>



// WEBPACK FOOTER //
// src/pages/ShoppingCart.vue